// import TriggerButton from 'components/triggerButton/TriggerButton';
import React, { useState } from 'react'
import { useSelector } from 'react-redux';
import {useLocation, useNavigate} from 'react-router-dom';
import auth from 'utils/Auth';
import { useTranslation } from 'react-i18next'
import DeliveryTypeApprovalModal from 'containers/modal/DeliveryTypeApprovalModal';
const NavbarTab = ({isSearchOpen}) => {
    const { popup } = useSelector((state) => state)
	const { triggerPopups } = popup
    const [announcementModal, setAnnouncementModal] = useState({open: false, content: null})
    const [activeTab, setActiveTab] = useState(auth?.getUserChoises()?.deliveryTab);
    const location = useLocation()
    const navigate = useNavigate()
    const { t } = useTranslation()
    const datas = [
        {
            name: t('cometoMyAddress'),
            id: 2
        },
        {
            name: t('buyFromBranch'),
            id: 1
        }
    ]
    const handleEventListener = (e, data) => {
		for (let triggerPopup of triggerPopups) {
			if (e.target.id == triggerPopup.triggerReference) {
				e.preventDefault();
				setAnnouncementModal({open:true, content:triggerPopup, data: data})
				e.currentTarget.click();
			}
		}
    }

    const tabSelect = (data) => {
        setActiveTab(data.id)
        auth.updateUserChoises({deliveryTab: data.id})
        navigate('/teslimat-secimi')
    }

    return (
        auth.isHaveToken() && <div className='navbar-tab'>
            {
                datas.map((data, i) => (
                    isSearchOpen 
                    // <TriggerButton key={i} disabled={location.pathname.includes('odeme')} onApprove={() => tabSelect(data)} data={data} activeTab={activeTab} referance='teslimat-tipi' />             
                    ?  <button key={i} id={"teslimat-tipi"} disabled={location.pathname.includes('odeme')} onClick={(e) => handleEventListener(e, data)} className={`navbar-tab-sub ${data.id == 2 ? "address" : "branch"} ${data.id == activeTab ? "navbar-tab-active" : ""}`}>{data.name}</button>
                    : <button key={i} onClick={() => navigate('/teslimat-secimi')} className={`navbar-tab-sub ${data.id == 2 ? "address" : "branch"} ${data.id == activeTab ? "navbar-tab-active" : ""}`}>{data.name}</button>
                ))
            }
           <DeliveryTypeApprovalModal onApprove={() => tabSelect(announcementModal.data)} announcementModal={announcementModal} setAnnouncementModal={setAnnouncementModal}/>
        </div>
    )
}

export default NavbarTab